import { observer } from 'mobx-react-lite'

import { groupStore } from '../../store/GroupStore'

import { MediaThumb } from './MediaThumb'
import type { TimelinePhotoRow } from './useGroupByDayAndRow'

import styles from './PhotoGallery.module.scss'

export const PhotoRow: React.FC<{
  row: TimelinePhotoRow
  showOwnerAvatar?: boolean
  showSimilarSearch?: boolean
}> = observer(function PhotoRow({
  row,
  showOwnerAvatar = false,
  showSimilarSearch = false,
}) {
  return (
    <div
      style={{
        gridTemplateColumns: row.fractions.map(f => `${f}fr`).join(' '),
        height: '100%',
      }}
      className={styles.photoRow}
    >
      {row.elements.map((asset, i) => {
        return (
          <div
            key={asset.id}
            className="relative h-full w-full p-px has-[:focus-visible]:z-10 has-[:focus-visible]:outline has-[:focus-visible]:outline-4 has-[:focus-visible]:outline-offset-[-4px] has-[:focus-visible]:outline-m3-primary"
          >
            <MediaThumb
              src={`${asset.thumbnail_url}.s`}
              comments={groupStore.getCommentCount(asset.commentsItemId)}
              ownerAvatar={asset.ownerAvatar}
              photo={asset}
              filename={asset.filename}
              duration={asset.duration}
              playIcon={asset.content === 'video'}
              showOwnerAvatar={showOwnerAvatar}
              showSimilarSearch={showSimilarSearch}
            />
          </div>
        )
      })}
    </div>
  )
})
